export const CUSTOM_ALLOCATION_TYPES = ['WEIGHTED', 'WATERFALL'];
export const GROUP_LABEL_MAX_LENGTH = 50;

export const DONATION_ALLOCATION_OPTIONS = [
  { value: 'EVEN', label: 'Default / Even split' },
  { value: 'WEIGHTED', label: 'Weighted allocation' },
  { value: 'WATERFALL', label: 'Waterfall' },
];

export const DONATION_ALLOCATION_LABELS = [
  {
    value: 'EVEN',
    label: 'Donation amounts will be evenly split amongst all recipients',
  },
  {
    value: 'WEIGHTED',
    label: 'Donation amounts will be split based on your organization’s amount designation',
  },
  {
    value: 'WATERFALL',
    label:
      'Donation amounts will be split based on your organization’s amount and priority designation',
  },
];
